import { Checkbox, CheckboxProps } from '@mui/material'
import { FC } from 'react'

export type C1CheckboxProps = Omit<CheckboxProps, 'variant'>

/**
 * Checkbox input for boolean or multi-select choices.
 *
 * @designSystem
 * @designSystemProps checked, onChange, disabled, indeterminate, color, size
 * @category c1ui
 * @relatedComponents C1Button
 */
export const C1Checkbox: FC<C1CheckboxProps> = (props) => <Checkbox {...props} />
